import { type MouseEvent, useCallback } from 'react'
import type { RowType } from '../typings'
import type { UseData } from './useData'

type Props = Pick<UseData, 'setMenuState'>

export function useHandlers(props: Props) {
  const { setMenuState } = props

  const rowMenuClick = useCallback(
    (e: MouseEvent<HTMLElement>, row: RowType) =>
      setMenuState({ anchorEl: e.currentTarget, row }),
    [setMenuState],
  )

  const onCloseRowMenu = useCallback(
    () => setMenuState((s) => ({ ...s, anchorEl: null })),
    [setMenuState],
  )

  return {
    rowMenuClick,
    onCloseRowMenu,
  }
}
